import { inject } from '@angular/core';
import { HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { delay, finalize, of, switchMap, tap } from 'rxjs';
import { LoadingService } from '../loading.service';

export function authInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn) {

    const loadingService = inject(LoadingService);

    let token = null;

    const newRequest = token ? request.clone({headers: request.headers.set('Authorization', `Bearer ${token}`)}) : request;

    return of('').pipe(delay(500), switchMap(() => next(newRequest)));

}